import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CarbonFootprintsPage } from '@/areas/settings/procurement-intelligence/Settings/CarbonFootprintsPage/CarbonFootprintsPage';
import { canViewCarbonFootprintsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/carbon-footprints')({
    staticData: { access: { permissions: canViewCarbonFootprintsSettings }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CarbonFootprintsPage />;
}
